<template>
  <div>
    <index-navbar />
     <main>
    <section
      class="header relative pt-16 items-center flex h-screen max-h-860-px"
    >
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
          <div class="pt-32 sm:pt-0">
            <h2 class="font-semibold text-4xl text-blueGray-600">
              AmeiseTech is a  Smart Infra Startup providing  Digital solutions to drive Sustainability.
            </h2>
            <p class="mt-4 text-lg leading-relaxed text-blueGray-500">
Ameisetech is your digital transformation partner in achieving Net-Zero excellence and integrating resource efficiency. We deliver sustainable digital transformation by prioritizing resource efficiency and lifecycle management in all our ICT and MSI deployments. Sustainability is at the heart of everything we do—whether it’s design, program management, services, or innovation—ensuring that every solution we provide contributes to a greener and more responsible future              <a
                
                class="text-blueGray-600"
                target="_blank"
              >
              </a>
              
            </p>
            <!-- <div class="mt-12">
              <a
                href="https://www.creative-tim.com/learning-lab/tailwind/vue/overview/notus?ref=vn-index"
                target="_blank"
                class="get-started text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-emerald-500 active:bg-emerald-600 uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
              >
                Calculate Your Carbon Footprint
              </a>
            </div> -->
          </div>
        </div>
      </div>

      <img
        class="absolute top-0 b-auto right-0 pt-16 sm:w-6/12 -mt-48 sm:mt-0 w-10/12 max-h-860-px" style="padding-top: 5rem; padding-right: 5rem;"
        :src="patternVue"
        alt="..."
      />
    </section>
    <section class="mt-48 md:mt-40 pb-40 relative bg-blueGray-100">
      <!-- <div
        class="-mt-20 top-0 bottom-auto left-0 right-0 w-full absolute h-20"
        style="transform: translateZ(0);"
      >
        <svg
          class="absolute bottom-0 overflow-hidden"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          version="1.1"
          viewBox="0 0 2560 100"
          x="0"
          y="0"
        >
          <polygon
            class="text-blueGray-100 fill-current"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div> -->
      <div class="container mx-auto">
        <div class="flex flex-wrap items-center">
          <div
            class="w-10/12 md:w-6/12 lg:w-4/12 px-12 md:px-4 mr-auto ml-auto -mt-32"
          >
            <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-emerald-500"
            >
              <img
                alt="..."
                src="@/assets/img/AI-Remove.jpg"
                class="w-full align-middle rounded-t-lg"
              />
              <blockquote class="relative p-8 mb-4">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="absolute left-0 w-full block h-95-px -top-94-px"
                >
                  <polygon
                    points="-30,95 583,95 583,65"
                    class="text-emerald-500 fill-current"
                  ></polygon>
                </svg>
                <h4 class="text-xl font-bold text-white">
                  AI & Digital Solutions for a Sustainable Future
                </h4>
                <p class="text-md mt-2 text-white">
                  We leverage the power of Artificial Intelligence and cutting-edge digital technologies to drive sustainability across industries. Our innovative solutions help organizations reduce their environmental impact, optimize resource usage, and achieve their sustainability goals. From smart infrastructure to intelligent data analytics, we are committed to creating a greener, more sustainable future through technology.
                <a href="/sustainability-consulting" class="text-white underline">Read more</a>
                </p>
              </blockquote>
            </div>
          </div>

          <div class="w-full md:w-6/12 px-4">
            <div class="flex flex-wrap">
              <div class="w-full md:w-6/12 px-4">
                <div class="relative flex flex-col mt-4">
                  <div class="px-4 py-5 flex-auto">
                    <div
                      class="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white"
                    >
                      <i class="fas fa-sitemap"></i>
                    </div>
                    <h6 class="text-xl mb-1 font-semibold">
                      Services
                    </h6>
                    <p class="mb-4 text-blueGray-500">
                      We offer a range of services including Sustainability Consulting, Contract Design, Financial Modelling, and Operation & Maintenance Support.
                    <a href="/contract-design" class="text-blueGray-500 hover:text-blueGray-700 underline">
                      Read more
                    </a>
                    </p>
                    
                  </div>
                </div>
                <div class="relative flex flex-col min-w-0">
                  <div class="px-4 py-5 flex-auto">
                    <div
                      class="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white"
                    >
                      <i class="fas fa-drafting-compass"></i>
                    </div>
                    <h6 class="text-xl mb-1 font-semibold">
                      Software Services
                    </h6>
                    <p class="mb-4 text-blueGray-500">
                      We assist organizations in designing and implementing software solutions that align with their sustainability and regulatory goals.
                    <a href="/software-services" class="text-blueGray-500 hover:text-blueGray-700 underline">
                      Read more
                    </a>
                    </p>
                    
                  </div>
                </div>
              </div>
              <div class="w-full md:w-6/12 px-4">
                <div class="relative flex flex-col min-w-0 mt-4">
                  <div class="px-4 py-5 flex-auto">
                    <div
                      class="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white"
                    >
                      <i class="fas fa-newspaper"></i>
                    </div>
                    <h6 class="text-xl mb-1 font-semibold"> System Integration </h6>
                    <p class="mb-4 text-blueGray-500">
Our System Integration services ensure that all your IT assets — whether legacy systems, cloud applications, or third-party solutions
<a href="/Services" class="text-blueGray-500 hover:text-blueGray-700 underline">
                      Read more
                    </a>
</p>
                    
                  </div>
                </div>
                <div class="relative flex flex-col min-w-0">
                  <div class="px-4 py-5 flex-auto">
                    <div
                      class="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white"
                    >
                      <i class="fas fa-file-alt"></i>
                    </div>
                    <h6 class="text-xl mb-1 font-semibold">
                       Operation & Maintenance Support
                    </h6>
                    <p class="mb-4 text-blueGray-500">
                      We provide ongoing support and maintenance services to ensure the long-term sustainability of our clients' operations.
                    <a href="/contract-design#operation-maintenance" class="text-blueGray-500 hover:text-blueGray-700 underline">
                      Read more
                    </a>
                    </p>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="Servicess" class="container mx-auto overflow-hidden pb-20">
        <div class="flex flex-wrap items-center">
          <div class="w-full md:w-4/12 px-12 md:px-4 ml-auto mr-auto mt-48">
            <!-- <div
              class="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white"
            >
              <i class="fas fa-sitemap text-xl"></i>
            </div> -->
            <h3 class="text-3xl mb-2 font-semibold leading-normal">
              Our Vision:
            </h3>
            <p
              class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-500"
            >
              Our vision is to be recognized as a global leader and trusted partner in next-generation information technology solutions. With a passionate team of technocrats, we empower clients to achieve superior value from their technology investments through innovation and excellence.
We are committed to going beyond expectations—building robust infrastructure, upholding strong work ethics, and addressing the opportunities of emerging markets.
By earning trust, delivering only the best, and nurturing long-lasting relationships, we aspire to make technology a force for progress and help shape a better, more connected world.
            </p>

            <h3 class="text-3xl mb-2 font-semibold leading-normal">
              Innovation and Leadership:
            </h3>
            <p
              class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-600"
            >
              We strive to be at the forefront of technological innovation, continuously exploring new ideas and solutions to meet the evolving needs of our clients and the industry.
            </p>
            <h3 class="text-3xl mb-2 font-semibold leading-normal">
              Customer-Centric Approach:
            </h3>
            <p
              class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-600"
            >
              We prioritize our clients' needs and work collaboratively to deliver tailored solutions that drive success and satisfaction.
            </p>
            <!-- <div class="block pb-6">
              <span
                class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2"
              >
                Buttons
              </span>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2"
              >
                Inputs
              </span>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2"
              >
                Labels
              </span>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2"
              >
                Menus
              </span>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2"
              >
                Navbars
              </span>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2"
              >
                Pagination
              </span>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2"
              >
                Progressbars
              </span>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2"
              >
                Typography
              </span>
            </div>
            <a
              href="https://www.creative-tim.com/learning-lab/tailwind/vue/alerts/notus?ref=vn-index"
              target="_blank"
              class="font-bold text-blueGray-700 hover:text-blueGray-500 ease-linear transition-all duration-150"
            >
              View All
              <i class="fa fa-angle-double-right ml-1 leading-relaxed"></i>
            </a> -->
          </div>

          
          <div class="w-full md:w-6/12 mr-auto px-4 pt-24 md:pt-0 mt-48">
            <img
              alt="..."
              class="max-w-full rounded-lg shadow-xl"
              style="
                transform: scale(1) perspective(1040px) rotateY(-11deg)
                  rotateX(2deg) rotate(2deg); "
              :src="documentation"
            />
          </div>
        </div>

        <!-- <div class="flex flex-wrap items-center pt-32">
          <div class="w-full md:w-6/12 px-4 mr-auto ml-auto mt-32">
            <div class="justify-center flex flex-wrap relative">
              <div class="my-4 w-full lg:w-6/12 px-4">
                
                  <div class="bg-gradient-500 shadow-lg rounded-lg text-center p-8">
                    <img
                      alt="..."
                      class="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                      src="@/assets/img/experience.png"
                    />
                    <p class="text-lg text-white mt-4 font-semibold">
                      Proven Expertise
                    </p>
                  </div>
                
                  <div
                    class="bg-gradient-500 shadow-lg rounded-lg text-center p-8 mt-8"
                  >
                    <img
                      alt="..."
                      class="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                      src="@/assets/img/solution.png"
                    />
                    <p class="text-lg text-white mt-4 font-semibold">
                      Innovative Solutions
                    </p>
                  </div>
                
                  <div
                    class="bg-gradient-500 shadow-lg rounded-lg text-center p-8 mt-8"
                  >
                    <img
                      alt="..."
                      class="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                      src="@/assets/img/consumer-centric.png"
                    />
                    <p class="text-lg text-white mt-4 font-semibold">
                      Client-Centric Approach
                    </p>
                  </div>
                
              </div>
              <div class="my-4 w-full lg:w-6/12 px-4 lg:mt-16">
                
                  <div
                    class="bg-gradient-500 shadow-lg rounded-lg text-center p-8"
                  >
                    <img
                      alt="..."
                      class="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                      src="@/assets/img/badge.png"
                    />
                    <p class="text-lg text-white mt-4 font-semibold">
                      Quality & Reliability
                    </p>
                  </div>
                
                  <div
                    class="bg-gradient-500 shadow-lg rounded-lg text-center p-8 mt-8"
                  >
                    <img
                      alt="..."
                      class="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                      src="@/assets/img/customer-service.png"
                    />
                    <p class="text-lg text-white mt-4 font-semibold">
                      End-to-End Support
                    </p>
                  </div>
                
               
                  <div
                    class="bg-gradient-500 shadow-lg rounded-lg text-center p-8 mt-8"
                  >
                    <img
                      alt="..."
                      class="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                      src="@/assets/img/ecology.png"
                    />
                    <p class="text-lg text-white mt-4 font-semibold">
                      Sustainable Growth
                    </p>
                  </div>
                
              </div>
            </div>
          </div>

          <div class="w-full md:w-4/12 px-12 md:px-4 ml-auto mr-auto mt-48">
            <h3 class="text-3xl mb-2 font-semibold leading-normal">
              Why Choose Us
            </h3>
            <p
              class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-500"
            >
              At AmeiseTech, we don’t just deliver technology — we deliver trust, innovation, and measurable results. Here’s why clients choose us as their long-term partner
            </p>
            <ul class="list-disc list-inside">
              <li class="text-blueGray-500">
                <strong>Proven Expertise</strong> – Our team of skilled IT professionals brings years of experience across industries and technologies.
              </li>
              <li class="text-blueGray-500">
                <strong>Quality & Reliability</strong> – We follow global best practices, ensuring high-quality deliverables you can trust.
              </li>
              <li class="text-blueGray-500">
                <strong>Innovative Solutions</strong> – We design creative, future-ready solutions that solve today’s challenges and prepare you for tomorrow.
              </li>
              <li class="text-blueGray-500">
               <strong>End-to-End Support</strong> – From consulting to implementation and ongoing support, we are with you at every step of the journey.
              </li>
              <li class="text-blueGray-500">
                <strong>Quality & Reliability</strong> – We follow global best practices, ensuring high-quality deliverables you can trust.
              </li>
            <li class="text-blueGray-500">
               <strong>Sustainable Growth</strong> – We focus on building solutions that not only drive business success but also align with ethical and sustainable practices.
              </li>
            </ul>
           
          </div>
        </div> -->
      </div>

     
    </section>

   
    <section class="py-20 bg-blueGray-600 overflow-hidden">
      <div class="container mx-auto ">
        <div class="flex flex-wrap justify-center">
          
<div class="w-full md:w-6/12 px-12 md:px-4">             
<h2 class="font-semibold text-4xl" style="
    color: white;
    text-align: center;
">Global Presence</h2><p class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-500" style="
    text-align: center;
    color: white;
"> We have successfully delivered projects across Europe, and Asia, demonstrating our ability to adapt to diverse markets and regulatory environments. </p></div>
          <div class="w-full md:w-9/12 px-4 mr-auto ml-auto mt-32 relative" style="    margin-top: 2rem;
">
            <map-example />
            <!-- <i
              class="fa fa-globe text-blueGray-700 text-55 absolute -top-150-px -right-100 left-auto opacity-80"
            ></i> -->
          </div>
        </div>
      </div>
    </section>
</main>
     <footer-component />
  </div>
</template>
<script>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import MapExample from "@/components/Maps/MapExample.vue";

import patternVue from "@/assets/img/bgimage.png";
import componentBtn from "@/assets/img/component-btn.png";
import componentProfileCard from "@/assets/img/component-profile-card.jpg";
import componentInfoCard from "@/assets/img/component-info-card.png";
import componentInfo2 from "@/assets/img/component-info-2.jpg";
import componentMenu from "@/assets/img/component-menu.png";
import componentBtnPink from "@/assets/img/component-btn-pink.png";
import documentation from "@/assets/img/mission.webp";
import login from "@/assets/img/login.jpg";
import profile from "@/assets/img/profile.jpg";
import landing from "@/assets/img/landing.jpg";

export default {
  data() {
    return {
      patternVue,
      componentBtn,
      componentProfileCard,
      componentInfoCard,
      componentInfo2,
      componentMenu,
      componentBtnPink,
      documentation,
      login,
      profile,
      landing,
    };
  },
  components: {
    IndexNavbar,
    FooterComponent,
    MapExample,
  },
};
</script>
